import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../ui/button';

export const CTASection = () => {
  return (
    <section data-testid="cta-section" className="relative py-24 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1920&q=80"
          alt="Luxury Living Room"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-leather/85"></div>
      </div>

      <div className="container-custom relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto text-center"
        >
          <span className="text-gold font-body text-sm uppercase tracking-widest">
            Ready to Transform Your Space?
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-white mt-4 mb-6">
            Get Your Dream Couch Today
          </h2>
          <p className="text-white/70 font-body text-lg mb-10">
            Whether you need a custom-built couch, want to browse our collection, 
            or restore your existing furniture, we're here to help.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/quote">
              <Button 
                data-testid="cta-get-quote-btn"
                className="btn-gold rounded-full px-10 py-4 text-base font-semibold"
              >
                Get Free Quote
                <i className="fas fa-arrow-right ml-2"></i>
              </Button>
            </Link>
            <a 
              href="https://wa.me/27752781104"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button 
                data-testid="cta-whatsapp-btn"
                variant="outline"
                className="rounded-full px-10 py-4 text-base font-semibold border-white text-white hover:bg-white hover:text-leather"
              >
                <i className="fab fa-whatsapp mr-2"></i>
                WhatsApp Us
              </Button>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
